import {useMutation} from '@apollo/react-hooks';

import type {ChannelType} from 'nutshell-graphql-types';
import type {
    LeadRemoveChannel as LeadRemoveChannelMutation,
    LeadRemoveChannelVariables as LeadRemoveChannelMutationVariables,
    GetLeadChannels,
} from 'nutshell-graphql-types';

import LEAD_REMOVE_CHANNEL from '../graphql/mutations/lead-remove-channel.graphql';
import GET_LEAD_CHANNELS from '../graphql/queries/get-lead-channels.graphql';

export function useRemoveChannel(): (arg1: {
    channel: ChannelType | null | undefined;
    leadId: string;
}) => Promise<any> {
    const [removeChannel] = useMutation<
        LeadRemoveChannelMutation,
        LeadRemoveChannelMutationVariables
    >(LEAD_REMOVE_CHANNEL);

    return (input: {channel: ChannelType | null | undefined; leadId: string}) => {
        return removeChannel({
            variables: {
                input: {
                    channel: !input.channel ? null : input.channel,
                    leadId: input.leadId,
                },
            },
            optimisticResponse: {
                leadRemoveChannel: {
                    __typename: 'LeadRemoveChannelPayload',
                    lead: {
                        __typename: 'Lead',
                        id: input.leadId,
                    },
                },
            },
            update: (proxy) => {
                const cacheResult: GetLeadChannels | null | undefined = proxy.readQuery({
                    query: GET_LEAD_CHANNELS,
                    variables: {id: input.leadId},
                });

                if (cacheResult && cacheResult.lead && cacheResult.lead.channels) {
                    const newChannels = cacheResult.lead.channels.edges.filter(
                        (channel) => channel.node.value !== input.channel
                    );

                    if (cacheResult.lead) {
                        proxy.writeQuery({
                            query: GET_LEAD_CHANNELS,
                            variables: {id: input.leadId},
                            data: {
                                lead: {
                                    ...cacheResult.lead,
                                    channels: {
                                        ...cacheResult.lead.channels,
                                        edges: newChannels,
                                    },
                                },
                            },
                        });
                    }
                }
            },
        });
    };
}
